export var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/icon/dist/esm/constants.js
// module id = 304
// module chunks = 0